export function modal_ajax_error_handler (xhr, status, errorstr) {
    let body = 'Sorry, an error has occurred';
    try {
        let message = JSON.parse(xhr.responseText).message;
        if (message) {
            body = message;
        }
    } catch (error) {

    }
    new ModalAjaxError({
        title: 'Error',
        body: body,
        url_parameters: {
            response: xhr.responseText,
            status: status,
            error: errorstr
        }
    }).show();
};



// WEBPACK FOOTER //
// ./assets/es6/common/modal/_ajax_error_handler.es6